module.exports = "<app-route-edit-technical route=$ctrl.route on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)></app-route-edit-technical> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/technical/template.html
// module id = 489
// module chunks = 0